import { IconsService } from '$services/icons/icons.service';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { take } from 'rxjs/operators';
import { ConfirmService } from '$services/confirm.service';
import { Observable } from 'rxjs';
import { ContactService } from './contact.service';
import { ContactMessageForm } from '$types';


@Component({
  selector: 'app-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.css']
})
export class ContactPageComponent implements OnInit {
  contactForm!: FormGroup
  @ViewChild('autosize') autosize!: CdkTextareaAutosize

  constructor(
    private readonly icons: IconsService,
    private readonly _ngZone: NgZone,
    private readonly contactService: ContactService,
    
  ) {
    this.icons.registerIcon([
      'check',
      'send'])
  }

  ngOnInit(): void {
    this.contactForm = this.contactService.buildForm()
  }
  onSubmit($event: SubmitEvent):void {
    
    $event.preventDefault()

    this.contactService.askAndSend(this.data)

  }

  get data(): ContactMessageForm{
    return {
      gender: +this.contactForm.get('gender')!.value,
      lastName: this.contactForm.get('lastName')!.value,
      email: this.contactForm.get('email')!.value,
      firstName: this.contactForm.get('firstName')!.value,
      landlinePhoneNumber: this.contactForm.get('landlinePhoneNumber')!.value,
      mobilePhoneNumber: this.contactForm.get('mobilePhoneNumber')!.value,
      questionType: +this.contactForm.get('questionType')!.value,
      message: this.contactForm.get('message')!.value,
    }
  }

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
  }
  getFormControlIconClassname(controlName: string[] | string): string {

    if (typeof controlName === 'string') {
      return this.contactForm.get(controlName)!.valid ?

        'contact__input__check-icon' : 'contact__input__check-icon-hidden'
    }
    if (Array.isArray(controlName)) {

      const allok = controlName.map(s => this.contactForm.get(s)!.valid).reduce((p, c) => p && c)

      return allok ? 'contact__input__check-icon' : 'contact__input__check-icon-hidden'
    }

    return 'contact__input__check-icon-hidden'
  }
}